"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../utilities/colors");
const FilledAreaLine = _ref => {
  let {
    color,
    line,
    xMin,
    xMax,
    yMin,
    yMax,
    yZero,
    onClick = () => {},
    onMouseOver = () => {},
    onMouseOut = () => {}
  } = _ref;
  const parsedLine = {
    key: 0,
    color: (0, colors_1.parseColor)(color, colors_1.DEFAULT_COLORS[0]),
    forceRedraw: lodash_1.default.uniqueId()
  };
  const gradientId = `line-gradient-${lodash_1.default.uniqueId()}`;
  let zeroPercent = 100;
  if (yZero !== yMax) {
    zeroPercent = Math.round(yZero / (yMax + yMin) * 100);
  }
  const areaFillPath = `L${xMax},${yZero}L${xMin},${yZero}Z`;
  return react_1.default.createElement(react_1.default.Fragment, null, [parsedLine].map(_ref2 => {
    let {
      color,
      key
    } = _ref2;
    return react_1.default.createElement("g", {
      key: key
    }, react_1.default.createElement("defs", null, react_1.default.createElement("linearGradient", {
      id: gradientId,
      x1: "0%",
      x2: "0%",
      y1: "0%",
      y2: "100%",
      onMouseOver: event => onMouseOver(event),
      onMouseOut: event => onMouseOut(event),
      onClick: event => onClick(event)
    }, react_1.default.createElement("stop", {
      offset: "0%",
      stopColor: color,
      stopOpacity: "0.5"
    }), react_1.default.createElement("stop", {
      offset: "100%",
      stopColor: "#FFFFFF",
      stopOpacity: "0.5"
    }), zeroPercent < 100 && react_1.default.createElement("stop", {
      offset: "100%",
      stopColor: color,
      stopOpacity: "0.5"
    }))), react_1.default.createElement("path", {
      fill: `url(#${gradientId})`,
      d: line + areaFillPath
    }));
  }));
};
FilledAreaLine.propTypes = {
  /** svg path used to draw line */
  line: prop_types_1.string.isRequired,
  /** color used to render gradient */
  color: prop_types_1.string,
  /** Used in conjunction with xMax to create the horizontal limits of the gradient bounding box */
  xMin: prop_types_1.number.isRequired,
  /** Used in conjunction with xMin to create the horizontal limits of the gradient bounding box */
  xMax: prop_types_1.number.isRequired,
  /** Used in conjunction with yMax to create the vertical limits of the gradient bounding box */
  yMin: prop_types_1.number.isRequired,
  /** Used in conjunction with yMin to create the vertical limits of the gradient bounding box */
  yMax: prop_types_1.number.isRequired,
  /** yZero is used to calculate where to flip gradient direction */
  yZero: prop_types_1.number.isRequired,
  /**
   * function to activate on click
   * parameters: (event)
   */
  onClick: prop_types_1.func,
  /**
   * function to activate on mouseOver
   * parameters: (event)
   */
  onMouseOver: prop_types_1.func,
  /**
   * function to activate on mouseOut
   * parameters: (event)
   */
  onMouseOut: prop_types_1.func
};
exports.default = FilledAreaLine;